import React from "react";

import navigationConfig from "../../dashboard-configs/navigationConfig";

import DashboardNavGroup from "./sections/DashboardNavGroup";
import DashboardNavCollapse from "./sections/DashboardNavCollapse";
import DashboardNavItem from "./sections/DashboardNavItem";
import DashboardNavLink from "./sections/DashboardNavLink";

const DashboardNavigation = () => (
  <nav className="test-list">
    {navigationConfig.map((item) => (
      <React.Fragment key={item.id}>
        {item.type === "group" && <DashboardNavGroup item={item} />}

        {item.type === "collapse" && <DashboardNavCollapse item={item} />}

        {item.type === "item" && <DashboardNavItem item={item} />}

        {item.type === "link" && <DashboardNavLink item={item} />}

        {item.type === "divider" && <hr className="cu-bg-gray-dark" />}
      </React.Fragment>
    ))}
  </nav>
);

export default DashboardNavigation;
